module.exports = __webpack_public_path__ + "static/media/listing-ad.bd999172.png";